import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight, Home } from "lucide-react";
import { isRTL } from "@/i18n";

export default function Breadcrumb({ items }) {
  const { i18n } = useTranslation();
  const rtl = isRTL(i18n.language);
  const Chevron = () => <ChevronRight className={`w-3.5 h-3.5 text-[#4A5568]/40 shrink-0 ${rtl ? "rotate-180" : ""}`} />;

  return (
    <nav data-testid="breadcrumb" className="flex items-center gap-2 text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <Link to={`/${i18n.language}`} className="flex items-center gap-1 text-[#4A5568] hover:text-[#D4AF37] transition-colors">
        <Home className="w-3.5 h-3.5" />
      </Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-2">
          <Chevron />
          {item.href ? (
            <Link to={item.href} className="text-[#4A5568] hover:text-[#D4AF37] transition-colors">{item.label}</Link>
          ) : (
            <span className="text-[#0A192F] font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
